import { useState } from "react";
import { useBoolean } from "usehooks-ts";
import { ResizeHandlesWrapper } from "../generic";
import { type YoutubeBlock } from "./types";

export const YoutubePreview = ({ block, editor }: YoutubeBlock) => {
  const [width, setWidth] = useState<number>(
    Math.min(
      block.props.previewWidth!,
      editor.domElement.firstElementChild!.clientWidth
    )
  );
  const { videoId, fullWidth } = block.props;
  const { value, setTrue, setFalse } = useBoolean(false);
  return (
    <ResizeHandlesWrapper
      block={block}
      editor={editor}
      width={width}
      setWidth={setWidth}
      onResizeStart={setTrue}
      onResizeEnd={setFalse}
    >
      {!value ? (
        <iframe
          src={!value ? `https://www.youtube.com/embed/${videoId}` : undefined}
          style={{
            width: fullWidth ? "100%" : width,
            aspectRatio: "16/9",
          }}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      ) : (
        <div
          style={{
            width: fullWidth ? "100%" : width,
            aspectRatio: "16/9",
            backgroundColor: "#f4f4f4",
            border: value ? "1px solid red" : "none",
          }}
        />
      )}
    </ResizeHandlesWrapper>
  );
};
